// extracted by mini-css-extract-plugin
export var copyIcon = "_yh-2";
export var discountCard = "_yh-0";
export var discountCode = "_yh-3";
export var discountContent = "_yh-1";
export var loadingCard = "_yh-4";